import { call, put, takeLatest } from "redux-saga/effects";

import * as types from "./actionType";
import {
    FranchiseLicense_Get_Success,
    FranchiseLicense_Post_Success,
    FranchiseLicense_Api_Error,
} from "./action";
import { Franchise_License_API_GET, Franchise_License_API_POST } from "../../../helpers/backend_helper";





function* FranchiseLicenseGetSaga() {
    try {
        const response = yield call(Franchise_License_API_GET);

        yield put(
            FranchiseLicense_Get_Success(response)
        );
    } catch (error) {
        yield put(
            FranchiseLicense_Api_Error(error)
        );
    }
}



function* FranchiseLicensePostSaga({ payload }) {
    try {
        const response = yield call(
            Franchise_License_API_POST,
            payload
        );
        yield put(
            FranchiseLicense_Post_Success(response)
        );
    } catch (error) {
        yield put(
            FranchiseLicense_Api_Error(error)
        );
    }
}


function* FranchiseLicenseSaga() {
    yield takeLatest(
        types.FRANCHISE_LICENSE_GET,
        FranchiseLicenseGetSaga
    );

    yield takeLatest(
        types.FRANCHISE_LICENSE_POST,
        FranchiseLicensePostSaga
    );
}

export default FranchiseLicenseSaga;